import classNames from "classnames";
import * as React from "react";

import styles from "../../../ClickableText.module.scss";
import { Color, COLORS } from "../../../consts";

type Props = {
  text?: string;
  color?: Color | string | null | undefined;
  className?: string;
  onClick?: () => void;
  children?: React.ReactNode;
  underlineOnHover?: boolean;
  id?: string;
};

const TextClickHandler = (props: Props) => {
  const { id, className, onClick, underlineOnHover, text, children, color } =
    props;
  return (
    <span
      id={id}
      className={classNames(styles.text, className, {
        [styles.blueText]: !color,
        [styles.greyText]: color === COLORS.GREY,
        [styles.whiteText]: color === COLORS.WHITE,
        [styles.underlineOnHover]: underlineOnHover,
        [styles.removeUnderlineOnHover]: !underlineOnHover
      })}
      onClick={onClick}
      data-test="TextLink__Link"
    >
      {children ? children : text}
    </span>
  );
};

export default TextClickHandler;
